import script from "./BeamTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BeamTable.vue?vue&type=script&setup=true&lang=js"

import "./BeamTable.vue?vue&type=style&index=0&id=0aa98ecc&lang=css"
import "./BeamTable.vue?vue&type=style&index=1&id=0aa98ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa98ecc"]])

export default __exports__